'use strict';
var ansiRegex = require('ansi-regex');
var re = new RegExp(ansiRegex().source); // remove the `g` flag
module.exports = re.test.bind(re);



//////////////////
// WEBPACK FOOTER
// ./node_modules/has-ansi/index.js
// module id = ./node_modules/has-ansi/index.js
// module chunks = 0